import type { BrowserOptions } from '@sentry/nextjs'

export const ignoredErrors: BrowserOptions['ignoreErrors'] = [
  'Write permission denied.',
  'ResizeObserver loop limit exceeded',
  'Script error.',
  //https://github.com/vercel/next.js/discussions/51551
  'ResizeObserver loop completed with undelivered notifications',
  'Cancel rendering route',
  // Thrown on purpose by the leave-page confirmation to abort the route change
  'navigation aborted by user',
  // https://app.rollbar.com/a/systemeio/fix/item/dashboard-frontend/4378
  "null is not an object (evaluating 't[e]')",
  //https://app.rollbar.com/a/systemeio/fix/item/dashboard-frontend/3399
  /The provided `href` \(.*\) value is missing query values \(.*\) to be interpolated properly/,
  // Dexie internal errors
  'Error creating or migrating Records table in database',
  'UnknownError Internal error.',
  'A mutation operation was attempted on a database that did not allow mutations.',
  /Error creating Records table \(.*\) - database or disk is full/,
  'DatabaseClosedError',
  'QuotaExceededError',
  // ACE Editor
  "Failed to execute 'importScripts' on 'WorkerGlobalScope'",
  // CROPPER
  'cropperPreview',
  "Cannot read properties of null (reading 'offsetWidth')",
  "Cannot read properties of undefined (reading 'width')",
  // React-international-phone
  'e is not iterable',
]

export const ignoredErrorTypes = ['DatabaseClosedError', 'RangeError']
